import Text from './Text';

const Lead = (props) => <Text componentName='lead' {...props} />;
export default Lead;
